// ** Road List Component
import Table from './Table';

// ** Styles
import '@styles/react/apps/app-roads.scss';
import { GET_ROADS_HISTORY_BY_USER_ID } from '../../../../../graphql/Query/roadshistory';
import { useQuery } from '@apollo/client';

const RoadsList = ({ id }) => {
  const variables = {
    roadId: id,
    userId: id,
    input: {
      page: 1,
      perPage: 5
    }
  };
  const { data, loading, refetch } = useQuery(GET_ROADS_HISTORY_BY_USER_ID, {
    variables,
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });

  return (
    <div className="road-activities-list">
      <Table
        store={data?.listUserRoadsHistory?.docs || []}
        data={{ ...data?.listUserRoadsHistory, docs: undefined }}
        loading={loading}
        variables={variables}
        handleFetching={refetch}
      />
    </div>
  );
};

export default RoadsList;
